import React from 'react'
import { Typography } from '@mui/material'
import * as S from '../DivergenceProductPage.styles'

interface FinishedStepProps {
  onFinish: () => void
}

const FinishedStep: React.FC<FinishedStepProps> = ({ onFinish }) => (
  <S.CountingForm>
    <S.CountingContainer>
      <Typography
        style={{
          fontWeight: 'bold',
          fontSize: '24px',
          textAlign: 'center',
        }}
      >
        Divergência Concluída
      </Typography>

      <Typography style={{ fontSize: '18px', textAlign: 'center', marginTop: '16px' }}>
        A contagem foi finalizada com sucesso!
      </Typography>
    </S.CountingContainer>

    <S.ContainerButton>
      <S.CustomButton
        title='Concluir'
        bgColor='confirm'
        hoverColor='confirmHover'
        letterColor='white'
        data-testid='button-finish-test-id'
        onClick={onFinish}
      />
    </S.ContainerButton>
  </S.CountingForm>
)

export default FinishedStep
